import { Component, OnInit, ViewChild, Inject, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalComponent } from '../../global/global.component';
import { FilterSettingsModel, IFilter, GridComponent, DataStateChangeEventArgs, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { SearchSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { casemanagerHTTPService } from './case-manager.service';
import { caseManagerList, sortingObj, GetCaseListBo, WhereCondition, columnWidth, functionpermission, ColumnChangeBO, searchfilterDetails } from './case-manager.model';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/service/general.service';
import { GetHTTPService } from './case-table.service';
import { Observable } from 'rxjs/Observable';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonHttpService } from 'src/app/common.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { CommonApiService } from 'src/app/commonapiservice';
@Component({
  selector: 'app-case-manager',
  templateUrl: './case-manager.component.html',
  styleUrls: ['./case-manager.component.scss'],
})

export class CaseManagerComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() fromClient: string;
  @Output() emitcasemanger = new EventEmitter<number>()
  CaseArray: caseManagerList[];
  Case: caseManagerList = new caseManagerList();
  CaseSendBO: GetCaseListBo = new GetCaseListBo();
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();
  SaveList: caseManagerList = new caseManagerList();
  clientEnable: boolean = false;
  clientedit: boolean = false;
  checkEmailValidation: boolean = false;
  ColumnArray: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: string;
  arraycol: any = [];
  CaseForm: FormGroup;
  filterItems: { [key: string]: string } = {
    'Name': 'Name',
    'street':'Street',
    'state':'State',
    'city':'City',
    'zip':'Zip',
    'county': 'County',
    'phone': 'Telephone',
    'Fax': 'Fax',
    'agencyPhoneNum': 'Agency Phone Number',
    'Email': 'Email'
  };
  stateList: any = [];
  SearchText: string = '';
  isSaveorUpdateBoolean:boolean=false;
  SearchColumn: { [key: string]: string } = { 'name': 'Name' };
  dropInstance: DropDownList;
  public searchSettings: SearchSettingsModel;
  public toolbar: ToolbarItems[];
  initialPage: object;
  filterOptions: FilterSettingsModel;
  @ViewChild('grid') public grid: GridComponent;
  filter: IFilter;
  Filter_drop: searchfilterDetails;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public isinitialLoad: boolean = false;
  public data: Observable<DataStateChangeEventArgs>;
  public casedata :Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  TotalCount: number;
  pagshort: sortingObj = new sortingObj();
  ModelType: string = 'edit';
  fp: functionpermission;
  valuechange: any = [];
  CaseManagerDataList: any = [];
  //isSaveorUpdateBoolean :boolean = false;
  constructor(private formBuilder: FormBuilder,@Inject(GetHTTPService) public gethttp: GetHTTPService, public http: HttpClient,public global: GlobalComponent, public commonhttp: CommonHttpService,
    public CommonAPI: CommonApiService,  public toastrService: ToastrService, public general: GeneralService , public getHTTPService :GetHTTPService ,public httpService: casemanagerHTTPService ,private ngxService: NgxUiLoaderService,) {
    this.global.agencyList();
    this.global.checkforlogout()
    
    this.data = CommonAPI;
    this.casedata = gethttp;
    this.CaseForm = this.formBuilder.group({
      name: [' ', Validators.required],
      street: ['',],
      state: [''],
      city: [''],
      zip: [''],
      Telephone: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      Email: ['', Validators.compose([Validators.email,])],
      Fax: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      Alternate_Fax: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      County: [''],
      AgencyPhoneNumber : [''],
    });
  }
  type: string = "";
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.CaseSendBO.orderColumn = state.sorted[0].name;
        this.CaseSendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      state.action.currentFilterObject.field === "phone" ? state.action.currentFilterObject.value = state.action.currentFilterObject.value.replace(' ', "").replace('(', "").replace(')', "").replace('-', "") : state.action.currentFilterObject.value;
      state.action.currentFilterObject.field === "fax" ? state.action.currentFilterObject.value = state.action.currentFilterObject.value.replace(' ', "").replace('(', "").replace(')', "").replace('-', "") : state.action.currentFilterObject.value;
      state.action.currentFilterObject.field === "agencyPhoneNum" ? state.action.currentFilterObject.value = state.action.currentFilterObject.value.replace(' ', "").replace('(', "").replace(')', "").replace('-', "") : state.action.currentFilterObject.value;
      this.CaseSendBO.field = state.action.currentFilterObject.field;
      this.CaseSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.CaseSendBO.operator = state.action.currentFilterObject.operator;
      this.CaseSendBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.CaseSendBO.field = "name";
        this.CaseSendBO.matchCase = false;
        this.CaseSendBO.operator = "startswith";
        this.CaseSendBO.value = "";
      }
    }

    this.getCase();
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Casemanager.Pagesize != state.take) {
          this.arraycol[0].Casemanager.Pagesize = state.take
        }

      }
    }
  }


  ngOnInit(): void {
    if (
      (this.global.globalAgencyId == null ||
        this.global.globalAgencyId == undefined ||
        this.global.globalAgencyId == "" ||
        this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") && (this.global.agencyCode == 'SUPERADMIN')) {
      return;
    }
    this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
  
     
    });
    this.conditionlist.push(new WhereCondition());
    this.toolbar = ['ColumnChooser'];
    this.SearchColumn.key = 'name';
    this.SearchColumn.value = 'Name';
    this.getCase();
    this.fp = new functionpermission();
    this.filepermissionget();
    this.filterOptions = { type: 'Menu' };
    // let pag = JSON.parse(this.global.globalColumn.column)[0]?.Casemanager.Pagesize;
    this.initialPage = {
      currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes
    };
    if (this.fromClient == "edit") {
      this.clientEnable = true;
    }
    if (this.fromClient == "view") {
      this.clientedit = true;
    }
  }
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })

      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {

        this.arraycol[0].Casemanager.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });

        });

        this.arraycol[0].Casemanager.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });

        });


        if (this.arraycol[0].Casemanager.ShowColumns.length != count1 || this.arraycol[0].Casemanager.HideColumns.length != count) {
          this.arraycol[0].Casemanager.ShowColumns = showarr;
          this.arraycol[0].Casemanager.HideColumns = hidearr;
          // this.SaveColumnwidth();
        }
      }
    }

    this.CaseSendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.CaseSendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }

  }
  /////////////////////////////////////////////////////////
  CaseCreateupdate(type: string) {
    if (type == 'new') {
      this.ModelType = 'new';
      this.CaseForm.reset();
      this.Case = new caseManagerList();
      this.valueschanges();
    }
    else {
      this.CaseForm.controls.Email?.setErrors(null)
      this.valueschanges();
      this.ModelType = 'edit';
    }

  }
  /////////////////////////////////////////////////////////
  selectCasedetails(caseDetails: caseManagerList) {
    this.Case = JSON.parse(JSON.stringify(caseDetails));
  }
  // =======================Grid Column selector ================ //
  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }
  /////////////////////////////////////////////////////////
  DemographicPhoneFormat() {
    this.Case.phone = this.general.converPhoneGoogleLib(this.Case.phone);
  }
  DemographicPhoneFormat1() {
    this.Case.fax = this.general.converPhoneGoogleLib(this.Case.fax);
  }
  DemographicPhoneFormat2() {
    this.Case.agencyPhoneNum = this.general.converPhoneGoogleLib(this.Case.agencyPhoneNum);
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  /////////////////////////////////////////////////////////
  Refresh() {
    this.SearchText = "";
    this.CaseSendBO.field = 'Name';
    this.CaseSendBO.value = "";
    this.CaseSendBO.pageitem = 10;
    this.CaseSendBO.currentpageno = 1;
    this.pagshort = new sortingObj();
    this.getCase();
    this.grid.clearFiltering();
    this.grid.clearSorting();
  }
  /////////////////////////////////////////////////////////
  Search() {
    this.CaseSendBO.field = this.SearchColumn.key;
    this.CaseSendBO.SearchColumn='Name';
    this.CaseSendBO.orderColumn='Name';
    this.CaseSendBO.value = this.SearchText;
    this.CaseSendBO.pageitem = 10;
    this.CaseSendBO.currentpageno = 1;
    this.pagshort.currentPgNo = 1;
    this.getCase();
  }
  /////////////////////////////////////////////////////////
  SaveOrUpdateCase() {
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    let Error ;
    Error = this.Case.agencyPhoneNum && phoneRegex.test(this.Case.agencyPhoneNum) ? false : "Please enter a valid Agency Phone Number";
    if(this.Case.agencyPhoneNum == null || this.Case.agencyPhoneNum == undefined || this.Case.agencyPhoneNum == '')
    {
     Error = false;
    }
    if (Error != false) {
       this.toastrService.error(Error);
       return;
     }
    this.isSaveorUpdateBoolean=true
    var saveList: caseManagerList = JSON.parse(JSON.stringify(this.Case));
    saveList.id = this.Case.id;
    saveList.phone = this.general.reconverPhoneGoogleLib(saveList.phone);
    saveList.fax = this.general.reconverPhoneGoogleLib(saveList.fax);
    saveList.agencyPhoneNum = this.general.reconverPhoneGoogleLib(saveList.agencyPhoneNum);

    this.httpService.saveupdate(saveList).pipe(takeUntil(this.onDestroy$)).subscribe((data: string) => {
      this.isSaveorUpdateBoolean=false
      if (data) {
        this.valueschanges();
        this.SaveList.id = data;
        if (this.ModelType == 'new') {
          this.toastrService.success('Case Manager Saved Successfully');
          document.getElementById('opencasemanModal1').click();
          this.getCase();
        }
        else {
          this.toastrService.success('Case Manager Updated Successfully');
          document.getElementById('opencasemanModal1').click();
          this.getCase();
        }

      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false
      if (err) {
        this.toastrService.error(err.error, 'Error'), 8000;
      }
    })
  }
 
  /////////////////////////////////////////////////////////
  deleteCase() {
    let url = "api/CaseManager/DeleteCaseManager/";
    this.CommonAPI.DeleteFunctionForDeleteHttp(this.Case.id,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data) {
        document.getElementById('deletemodal').click();
        this.getCase();
        this.toastrService.success('Case Manager Deleted successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.getCase();
        document.getElementById('openModal2').click();
      }

    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    }
    );
  }
  closecase() {
    document.getElementById('opencasemanModal1').click();
  }
 
  getCase() {
    this.ngxService.start()
    this.gethttp.execute(this.CaseSendBO);
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.CaseManagerDataList = data;
      count = count + 1;
    })
  }

  filepermissionget() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "Casemanager");
      // params.append("roleId", this.global.roleId);
      //params.append("agencyId", this.global.globalAgencyId)
      this.httpService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data != null) {
          this.fp = data;
        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }
  valueschanges() {
    this.valuechange = {
      Name: 0,
      County: 0,
      Telephone: 0,
      Fax: 0,
      AgencyPhoneNumber: 0,
      Email: 0,
    }
  }
  checkpopup(value) {
    if (value == "Name") {
      this.valuechange.Name++;
    }
    if (value == "County") {
      this.valuechange.County++;
    } if (value == "Telephone") {
      this.valuechange.Telephone++;
    } if (value == "Fax") {
      this.valuechange.Fax++;
    }
    if (value == "AgencyPhoneNumber") {
      this.valuechange.AgencyPhoneNumber++;
    }
    if (value == "Email") {
      this.checkEmailValidation = false;
      if (this.Case.email != null) {
        if (this.CaseForm.controls.Email.errors != null) {
          if (this.CaseForm.controls.Email.errors.invalidEmail) {
            this.checkEmailValidation = true;
            setTimeout(() => {
              this.toastrService.clear();
            }, 3000);
          }
          else {
            this.checkEmailValidation = false;
          }
        }
      }
      this.valuechange.Email++;
    }
  }
  openDialog() {
    if (this.valuechange.Email > 1 || this.valuechange.Name > 1 || this.valuechange.County > 1 ||
      this.valuechange.Telephone > 1 || this.valuechange.Fax > 1 || this.valuechange.AgencyPhoneNumber > 1) {
      document.getElementById('cancelcasemanmodal').click();
    }
    else {
      document.getElementById('opencasemanModal1').click();
    }
  }
  closeAddUpdateModal() {
    document.getElementById('opencasemanModal1').click();
    document.getElementById('cancelcasemanmodal').click();
  }
  onKeydown(event) {
    if (event.key === "Enter") {
      this.Search();
    }
  }
  setDefaultValue() {
    this.SearchText = "";
    if (this.SearchColumn == undefined)
      this.SearchColumn = {
      };
  }
  caseemit(data) {
    this.emitcasemanger.emit(data.id)
  }
  headerCellInfo(args) {
    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);
  }
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString(),
          position: 'RightCenter',
        }, args.cell as HTMLTableCellElement);
      }
    }
  }
  canceldelete() {
    document.getElementById('openModal2').click();
  }
  // getColumnwidth() {
  //   this.arraycol = JSON.parse(this.global.globalColumn.column);
  //   this.ColumnArray = this.arraycol[0].Casemanager.Columns;
  //   this.grid.hideColumns(this.arraycol[0].Casemanager.HideColumns);
  //   if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
  //     this.id = this.global.globalColumn.id;
  //   }
  //   this.grid.pageSettings.pageSize = this.arraycol[0].Casemanager.Pagesize;
  //   this.ColumnArray.forEach(element => {
  //     if (element.column == 'Name') {
  //       const column = this.grid.getColumnByField('name');
  //       column.width = element.width;
  //       this.grid.refreshHeader();
  //     }
  //     if (element.column == 'County') {
  //       const column1 = this.grid.getColumnByField('county');
  //       column1.width = element.width;
  //       this.grid.refreshHeader();
  //     }
  //     if (element.column == 'Telephone') {
  //       const column1 = this.grid.getColumnByField('phone');
  //       column1.width = element.width;
  //       this.grid.refreshHeader();
  //     }
  //     if (element.column == 'Fax') {
  //       const column1 = this.grid.getColumnByField('fax');
  //       column1.width = element.width;
  //       this.grid.refreshHeader();
  //     }
  //     if (element.column == 'Alternative Fax') {
  //       const column1 = this.grid.getColumnByField('alternate_Fax');
  //       column1.width = element.width;
  //       this.grid.refreshHeader();
  //     }
  //     if (element.column == 'Email') {
  //       const column1 = this.grid.getColumnByField('email');
  //       column1.width = element.width;
  //       this.grid.refreshHeader();
  //     }
  //     if (element.column == 'Actions') {
  //       const column2 = this.grid.getColumnByUid('action');
  //       column2.width = element.width;
  //       this.grid.refreshHeader();
  //     }
  //   });
  // }
  // SaveColumnwidth() {
  //   this.arraycol[0].Casemanager.Columns = this.ColumnArray;
  //   this.arraycol[0].Casemanager.Pagesize = this.grid.pageSettings.pageSize;
  //   this.columnchange.userid = parseInt(this.global.userID);
  //   this.columnchange.column = JSON.stringify(this.arraycol);
  //   this.columnchange.id = this.id;
  //   this.global.globalColumn = this.columnchange;
  //   this.arraycol = JSON.parse(this.global.globalColumn.column);
  //   let url = "api/ColumnChange/Savewidth?";
  //   this.CommonAPI.GetFunctionwithResponseTypeJson(this.columnchange,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     // this.getColumnwidth();
  //   });
  // }
  onResize(args) {
    if (this.ColumnArray != undefined && this.ColumnArray != null) {
      const column = this.grid.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      // this.SaveColumnwidth();
    }
  }
    //......................................exportCaseWithPaginationCsv.....................................................
    exportCaseWithPaginationCsv() {
        this.CaseSendBO.pageitem = this.grid.pageSettings.pageSize;
        this.CaseSendBO.currentpageno = this.grid.pageSettings.currentPage;
        if(this.CaseSendBO.field=='Name')
        {
          this.CaseSendBO.field='CaseManagerName';
        }
        this.CaseSendBO.SearchColumn='CaseManagerName';
        this.CaseSendBO.orderColumn='CaseManagerName';
        let url = "api/CaseManager/GetCaseManagerWithPageExcel";
        this.CommonAPI.saveorUpdateFunctionFileSaver(this.CaseSendBO, url, "CaseManagerReport.csv");
        if(this.CaseSendBO.field=='CaseManagerName')
          {
            this.CaseSendBO.field='Name';
          }
        this.CaseSendBO.SearchColumn='Name';
        this.CaseSendBO.orderColumn='Name';
    }
    //...........................................exportCaseCsv................................................................
    exportCaseCsv() {
      if(this.CaseSendBO.field=='Name')
        {
          this.CaseSendBO.field='CaseManagerName';
        }
        this.CaseSendBO.SearchColumn='CaseManagerName';
        this.CaseSendBO.orderColumn='CaseManagerName';

        let url = "api/CaseManager/GetCaseManagerExcel";
        this.CommonAPI.saveorUpdateFunctionFileSaver(this.CaseSendBO, url, "CaseManagerReport.csv")
        if(this.CaseSendBO.field=='CaseManagerName')
          {
            this.CaseSendBO.field='Name';
          }
        this.CaseSendBO.SearchColumn='Name';
        this.CaseSendBO.orderColumn='Name';
    }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
